import axios from "axios";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useRef, useState } from "react";
import EditCoverPage from "./EditCoverPage.js";
import EditIcon from '@mui/icons-material/Edit';
import ReportEditLayout from "./ReportEditLayout";
import { useSearchParams } from "react-router-dom";
import Preloader from "../../../helpers/Preloader";
import config_settings from "../../../config/config";
import ReportPreviewPages from "./ReportPreviewPages";
import "../../../../assets/styles/containers/_reportSettings.scss";
import { Box, Button, Card, Grid, Typography, Tab, Tabs } from "@mui/material";
import LaunchIcon from '@mui/icons-material/Launch';
import { IRURL } from "../../../config/app-constants";
import AntSwitch from "../../../common/antSwitch/AntSwitch";

let REPORT_SETTING_URL;

const origin = () => {
  let origin = window.location.origin.toLowerCase();
  if (origin.includes("https://")) origin = origin.replace("https://", "");
  else origin = origin.replace("http://", "");
  REPORT_SETTING_URL = config_settings[origin].REPORT_SETTING_URL;
};
origin();

const ReportSettingsLayout = () => {
  const fileInput = useRef();
  const editorRef = useRef();
  const [image, setImage] = useState("");
  const [value, setValue] = useState(0);
  const [tabValue, settabvalue] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [lastPublished, setLastPublished] = useState();
  const [defaultLogo, setDefaultLogo] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [editCoverModal, setEditCoverModal] = useState(false);
  const [useCompanyName, setUseCompanyName] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#334B8E");
  const [companyName, setCompanyName] = useState("company name");
  const [defaultCoverPageData, setDefaultCoverPageData] = useState();
  const [editorContent, setEditorContent] = useState({ innerHTML: "" });
  const [placeholderData, setPlaceholderData] = useState();
  const [isNarrative, setIsNarrative] = useState(false);
  const [buildRequestList, setBuildRequestList] = useState(false);
  const colorPalette = ["#6C2181", "#851313", "#C64B00", "#195803", "#0E4D5C", "#2F0881", "#038787", "#475803", "#571E1E", "#334B8E"];
  const OpenCoverModal = () => setEditCoverModal(true);
  const CloseCoverModal = () => { setEditCoverModal(false); setEditorContent({ innerHTML: defaultCoverPageData || "" }) }
  const handleChange = (event, newValue) => setValue(newValue);

  const replacePlaceholdersWithButtons = (htmlString, data) => {
    let updatedHTML = htmlString;
    Object.values(data).forEach((category) => {
      Object.entries(category).forEach(([key, value]) => {
        if (typeof value === "string" && value.trim() !== "") {
          const regex = new RegExp(value?.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g");
          updatedHTML = updatedHTML?.replace(regex, `{{${key}}}`);
        }
      });
    });
    return updatedHTML;
  };

  useEffect(() => {
    setShowLoader(true);
    if (sessionStorage.getItem("company_id") === null || sessionStorage.getItem("company_id") === "null") {
      sessionStorage.setItem("company_id", searchParams.get("key"));
      searchParams.delete("key");
      setSearchParams(searchParams);
    }
    const Header = { headers: { "company-key": sessionStorage.getItem("company_id") } };
    axios
      .post(`${REPORT_SETTING_URL}/get-company-html-report-settings`, "", Header)
      .then((res) => {
        let coverPageData = "";
        const { data, last_updated_at, cover_page_placeholders, is_ht_company } = res?.data;
        setImage("");
        coverPageData = replacePlaceholdersWithButtons(data?.cover_page, cover_page_placeholders?.isn);
        setEditorContent({ innerHTML: coverPageData || "" });
        const editorInstance = editorRef?.current?.editor;
        const editorContent = editorInstance?.html?.get();
        if (editorContent) editorInstance.html.set(coverPageData, true);
        setDefaultCoverPageData(coverPageData);
        setPlaceholderData(cover_page_placeholders?.palmtech)
        setIsNarrative(is_ht_company);
        setDefaultLogo(data?.company_logo_url === null ? null : data?.company_logo_url);
        setSelectedColor(data?.color_code || data?.color_code === "null" ? data?.color_code : "#334B8E");
        setCompanyName(data?.company_name);
        setUseCompanyName(data?.use_company_name_as_logo === 1 ? true : false);
        const reqListStatus = data?.is_request_list_enabled ?? res?.data?.is_request_list_enabled ?? res?.data?.data?.is_request_list_enabled;
        setBuildRequestList(reqListStatus == 1 || reqListStatus === "1" || reqListStatus === true || reqListStatus === "true");
        setShowLoader(false);
        setLastPublished(last_updated_at);
      })
      .catch(function (error) {
        if (error.response) {
          setShowLoader(false);
          setDefaultLogo(null);
          setSelectedColor("#334B8E");
          fileInput.current.value = "";
          if (error.response.data.status_code !== 404) {
            toast.error(error.response.data.message);
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
    // eslint-disable-next-line
  }, [refresh]);

  const parseAndReplaceHTML = (htmlString, data) => {
    return htmlString.replace(/{{(.*?)}}/g, (match, key) => {
      key = key.trim(); // Remove extra spaces
      let replacementValue = null;

      // Search for the key in the JSON data
      Object.values(data).forEach(category => {
        if (category[key]) {
          replacementValue = category[key]; // Get value from JSON
        }
      });
      return replacementValue !== null ? replacementValue : match; // Replace if found, else keep original {{value}}
    });
  };


  const sendSettings = () => {
    setShowLoader(true);
    const Header = {
      headers: { "company-key": sessionStorage.getItem("company_id") }
    };
    let formData = new FormData();
    const params = {
      is_deleted: 0,
      company_name: companyName,
      color_code: selectedColor,
      cover_page: parseAndReplaceHTML(editorContent.innerHTML, placeholderData),
      company_logo: image ? image : "",
      use_company_name_as_logo: useCompanyName ? 1 : 0,
    };
    Object.keys(params).forEach((key) => formData.append(key, params[key]));
    axios
      .post(`${REPORT_SETTING_URL}/store-company-html-report-settings`, formData, Header)
      .then((response) => {
        toast.success(response.data.message);
        fileInput.current.value = "";
        setShowLoader(false);
        setIsChanged(false);
        setRefresh(!refresh);
        CloseCoverModal()
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.data.success === false) {
            toast.error(error.response.data.message);
            setShowLoader(false);
          }
        } else if (error.request) {
          console.log("no response", error.request);
        } else {
          console.log("Error", error.message);
        }
      });
    };

  const updateRequestListStatus = (checked) => {
    const enableValue = checked ? 1 : 0;
    setBuildRequestList(checked);
    setShowLoader(true);
    const companyKey = sessionStorage.getItem("company_id") || sessionStorage.getItem("company-key");
    const config = {
      headers: { "company-key": companyKey, "Content-Type": "application/json" },
      params: {
        companyKey: companyKey,
        enableRequestList: enableValue,
      },
    };
    axios
      .post(`${REPORT_SETTING_URL}/update-request-list-status`, null, config)
      .then((res) => {
        setShowLoader(false);
        if (res?.data?.message) {
          toast.success(res.data.message);
        } else {
          toast.success("Request list status updated successfully");
        }
      })
      .catch((error) => {
        setShowLoader(false);
        setBuildRequestList(!checked);
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Failed to update request list status");
        }
    });
  };

  return (
    <>
      {showLoader ? <Preloader showPreloader /> : ""}
      <Box className="report-setting-container">
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <Typography className="report-title">Report Settings</Typography>
            <Typography className="report-title-desc">Manage settings for your PDF and interactive reports.</Typography>
            {!isNarrative ? <Box sx={{ borderBottom: '1px solid #ccc', marginTop: '20px', width: 'fit-content' }}>
              <Tabs
                value={value}
                onChange={handleChange}
                className="layout__tabs__select"
                TabIndicatorProps={{ style: { backgroundColor: '#239d80' } }}
              >
                <Tab className="layout__tabs__selected" label="Interactive Report"
                  sx={{ opacity: value !== 0 && 0.6, width: 'auto', paddingY: '20px', paddingX: '50px' }} onClick={() => settabvalue(0)}
                />
                <Tab className="layout__tabs__selected"
                  sx={{ opacity: value !== 1 && 0.6, width: 'auto', paddingY: '20px', paddingX: '50px' }} label="PDF Report" onClick={() => settabvalue(1)}
                />
              </Tabs>
            </Box> : null}
            {(value === 0 && !isNarrative) ? <Card className="report-card-container" style={{ minHeight: '36px' }} elevation={0}>
              <Grid container> <Grid item xs={8}>
                <Typography className="report_layout">Report Layout</Typography>
                <Typography className="report_layout_subtitle">Choose how your inspection data is presented</Typography>
              </Grid>
                <Grid item xs={4} display={"flex"} justifyContent={"flex-end"}>
                  <Button className="report-builder-button" endIcon={<LaunchIcon />} onClick={() => window.open(`${IRURL()}report-designer?key=${sessionStorage.getItem("company_id")}`, "_blank")} variant="contained">Open report designer</Button>
                </Grid>
              </Grid>
            </Card> : null}
            {(value === 1 || isNarrative) ?
              <>
                <Card className="report-card-container" elevation={0}>
                  <Typography className="report-preview-title">PDF Preview</Typography>
                  {/* Commented code might require later */}
                  {/* <Typography className="report-preview-desc">Select a face page layout for your PDF reports. Changes will affect future reports only.</Typography> */}
                  <div className="report-preview-card-container">
                    <ReportPreviewPages defaultLogo={defaultLogo} image={image} selectedColor={selectedColor} useCompanyName={useCompanyName} companyName={companyName} />
                  </div>
                </Card>
              </> : null}
            <br />
            <Card className="cover-page-container" elevation={0}>
              <Grid container sx={{ pt: 1 }}>
                <Grid item xs={8}>
                  <Typography className="report-preview-title">Cover page</Typography>
                  <Typography className="report-preview-desc">Create a default cover page to show after the face page in your PDF reports.</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Button className="edit-cover-button" startIcon={<EditIcon />} onClick={OpenCoverModal}>
                    Edit cover page
                  </Button>
                </Grid>
              </Grid>
            </Card>
            {isNarrative === 0 && (
              <Card className="cover-page-container" elevation={0} sx={{ mt: 2 }}>
              <Grid container alignItems="center">
                <Grid item xs={8}>
                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <Typography className="report-preview-title">BUILD REQUEST LIST</Typography>
                  </div>
                  <Typography className="report-preview-desc">Enable this option to allow users to create request lists from inspection report items.</Typography>
                </Grid>
                <Grid item xs={4} display="flex" justifyContent="flex-end" alignItems="center">
                  <AntSwitch
                    key={buildRequestList ? "enabled" : "disabled"}
                    defaultValue={buildRequestList}
                    defaultSwitchValue={(val) => updateRequestListStatus && updateRequestListStatus(val === "1")}
                  />
                </Grid>
              </Grid>
            </Card>
            )}
          </Grid>
          <Grid item xs={4}>
            <Card elevation={0} className="report-card-container-secondary">
              <ReportEditLayout
                companyName={companyName}
                setCompanyName={setCompanyName}
                lastPublished={lastPublished}
                isChanged={isChanged}
                sendSettings={sendSettings}
                defaultLogo={defaultLogo}
                setDefaultLogo={setDefaultLogo}
                setIsChanged={setIsChanged}
                fileInput={fileInput}
                image={image}
                setImage={setImage}
                colorPalette={colorPalette}
                selectedColor={selectedColor}
                setSelectedColor={setSelectedColor}
                setUseCompanyName={setUseCompanyName}
                useCompanyName={useCompanyName}
              />
            </Card>
          </Grid>
        </Grid>
        <EditCoverPage REPORT_SETTING_URL={REPORT_SETTING_URL} editorRef={editorRef} sendSettings={sendSettings} editorContent={editorContent} setEditorContent={setEditorContent} editCoverModal={editCoverModal} CloseCoverModal={CloseCoverModal} />
      </Box>
    </>
  );
};

export default ReportSettingsLayout;
